module.exports = __webpack_public_path__ + "static/media/Medium.eb3464bd.svg";